import { render } from "./ServiceUnitTimeForm.vue?vue&type=template&id=04b67f6d&scoped=true"
import script from "./ServiceUnitTimeForm.vue?vue&type=script&lang=js"
export * from "./ServiceUnitTimeForm.vue?vue&type=script&lang=js"

import "@/assets/stationForm.css?vue&type=style&index=0&id=04b67f6d&scoped=true&lang=css&external"
import "./ServiceUnitTimeForm.vue?vue&type=style&index=1&id=04b67f6d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04b67f6d"]])

export default __exports__